import * as yup from 'yup';

import { requiredField } from './utils/messages';

export const createCardFlagSchemaValidation = yup.object({
  name: yup.string().required(requiredField),
});
